module.exports = __webpack_public_path__ + "static/binDeleting-8cfd22fd1333bff75c671f7f80665e4b.gif";